import React, { useState, useEffect, useCallback } from 'react'
import { Row, Col, Space, Card } from 'antd';
import { List, Button, Modal, Toast } from 'antd-mobile'
import ajaxService from '../services/ajax-service';
import { withLocalize } from "react-localize-redux";
import SearchModal from './search-modal';
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Layout from '../layout';

const masalik = ['any', 'hanafi', 'maliki', 'shafi', 'hanbali', 'deobandi', 'ahlehadees', 'barelvi', 'salafi'];

const Details = ({ translate, activeLanguage }) => {

    const [namaz, setNamaz] = useState({});
    const [masjid, setMasjid] = useState();
    const [events, setEvents] = useState([]);

    const { state } = useLocation();
    let { id } = useParams();

    const renderNamaz = () => {
        if (Object.keys(namaz).length > 0) {

            const calculateMaghrib = (start, maghrib) => {
                if (!start || !maghrib || start === "N/A" || isNaN(maghrib)) return "N/A";
                const [h, m, s] = start.split(":").map(Number);
                const total = h * 3600 + m * 60 + (s || 0) + Number(maghrib) * 60;
                const hours = Math.floor(total / 3600) % 24;
                const minutes = Math.floor((total % 3600) / 60);
                const period = hours >= 12 ? "PM" : "AM";
                const displayHour = hours % 12 === 0 ? 12 : hours % 12;
                return `${displayHour.toString().padStart(2, "0")}:${minutes
                    .toString()
                    .padStart(2, "0")} ${period}`;
            };


            const formatStartTime = (time) => {
                if (!time || time === "N/A") return "N/A";
                if (time.toLowerCase().includes("am") || time.toLowerCase().includes("pm")) {
                    return time.toUpperCase();
                }

                const parts = time.split(":").map(Number);
                const h = parts[0];
                const m = isNaN(parts[1]) ? 0 : parts[1];

                const period = h >= 12 ? "PM" : "AM";
                const displayHour = h % 12 === 0 ? 12 : h % 12;
                const formatted = `${displayHour}:${m.toString().padStart(2, "0")} ${period}`;

                return formatted;
            };




            if (activeLanguage.code === 'en') {
                return (
                    <div>
                        <List mode="card">
                            <List.Item>{translate('home')}</List.Item>
                        </List>
                        <List mode="card">
                            <List.Item>
                                <Row>
                                    <Col span={6}>{translate('namaz')}</Col>
                                    <Col span={6} style={{ textAlign: 'right' }}>{translate('start')}</Col>
                                    <Col span={6} style={{ textAlign: 'right' }}>{translate('jamat')}</Col>
                                    <Col span={6} style={{ textAlign: 'right' }}>{translate('end')}</Col>
                                </Row>
                            </List.Item>
                            {Object.keys(namaz).map((item, index) => {
                                const start = formatStartTime(namaz[item][0]);

                                const jamat = item === 'maghrib'
                                    ? calculateMaghrib(namaz[item][0], namaz[item][1])
                                    : namaz[item][1];
                                const end = namaz[item][2];

                                return (
                                    <List.Item key={`namaz-item-${index}`}>
                                        <Row>
                                            <Col span={6}>{translate(item)}</Col>
                                            <Col span={6} style={{ textAlign: 'right' }}>{start}</Col>
                                            <Col span={6} style={{ textAlign: 'right' }}>{jamat}</Col>
                                            <Col span={6} style={{ textAlign: 'right' }}>{end}</Col>
                                        </Row>
                                    </List.Item>
                                );
                            })}
                        </List>
                    </div>
                );
            } else {
                return (
                    <div>
                        <List mode="card">
                            <List.Item>{translate('home')}</List.Item>
                        </List>
                        <List mode="card">
                            <List.Item>
                                <Row>
                                    <Col span={6}>{translate('namaz')}</Col>
                                    <Col span={6} style={{ textAlign: 'center' }}>{translate('start')}</Col>
                                    <Col span={6} style={{ textAlign: 'center' }}>{translate('jamat')}</Col>
                                    <Col span={6} style={{ textAlign: 'center' }}>{translate('end')}</Col>
                                </Row>
                            </List.Item>
                            {Object.keys(namaz).map((item, index) => {
                                const start = namaz[item][0];
                                const jamat = item === 'maghrib'
                                    ? calculateMaghrib(namaz[item][0], namaz[item][1])
                                    : namaz[item][1];
                                const end = namaz[item][2];

                                return (
                                    <List.Item key={`namaz-item-${index}`}>
                                        <Row>
                                            <Col span={6}>{translate(item)}</Col>
                                            <Col span={6} style={{ textAlign: 'center' }}>{start}</Col>
                                            <Col span={6} style={{ textAlign: 'center' }}>{jamat}</Col>
                                            <Col span={6} style={{ textAlign: 'center' }}>{end}</Col>
                                        </Row>
                                    </List.Item>
                                );
                            })}
                        </List>
                    </div>
                );
            }
        }
    };

    const renderMasjid = () => {
        if (masjid !== undefined) {

            return (
                <div>
                    <List mode="card" >
                        <List.Item >
                            {activeLanguage.code === 'en' ? masjid.name : masjid.name_ur}
                        </List.Item>
                    </List>
                    <List mode="card" >
                        <List.Item >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                <span>{translate('maslak')}</span>
                                <span>{translate(masalik[masjid.maslak])}</span>
                            </div>
                        </List.Item>
                        <List.Item >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                <span>{translate('contact')}</span>
                                <span>{masjid.phone}</span>
                            </div>
                        </List.Item>
                    </List>
                </div>
            );

        }
    }

    const renderEvents = () => {
        if (events.length > 0) {

            return events.map((event, index) => {
                return (
                    <List mode="card" key={`event-${index}`} >
                        <List.Item >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                <span>{translate('title')}</span>
                                <span>{activeLanguage.code === 'en' ? event.title : event.title_ur}</span>
                            </div>
                        </List.Item>
                        <List.Item >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                <span>{translate('khitab')}</span>
                                <span>{activeLanguage.code === 'en' ? event.speaker : event.speaker_ur}</span>
                            </div>
                        </List.Item>
                        <List.Item >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                <span>{translate('date')}</span>
                                <span>{event.date}</span>
                            </div>
                        </List.Item>
                        <List.Item >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                <span>{translate('time')}</span>
                                <span>{event.time}</span>
                            </div>
                        </List.Item>
                        <List.Item >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                <span>{activeLanguage.code === 'en' ? event.description : event.description_ur}</span>
                            </div>
                        </List.Item>
                    </List>
                );
            })
        }
    }

    const renderEventsSection = () => {
        if (events.length > 0) {
            return (
                <div>
                    <List mode="card" >
                        <List.Item >
                            {translate('upcoming_events')}
                        </List.Item>
                    </List>
                    {renderEvents()}
                </div>
            );

        }
    }

    useEffect(() => {
        const getMasjidDetails = async () => {
            let response = await ajaxService.get('masjid/view/' + id);

            if (response.data) {

                let { masjid, namaz, events } = response.data;

                setMasjid(masjid);
                setNamaz(namaz);
                setEvents(events);
            }
        }

        getMasjidDetails()
    }, [])

    return (
        <Layout>
            <div style={{ marginLeft: '30px', marginRight: '30px' }}>

                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    {renderMasjid()}
                    {renderNamaz()}
                    {renderEventsSection()}
                </Space>
            </div>
        </Layout>
    )
}

export default withLocalize(Details);